/**
 * 活动相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/system/sysImage/query',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        saveSysImage(data) {
            return http.json({
                url: '/system/sysImage/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getSysImage(data) {
            return http.json({
                url: `/system/sysImage/get?id=${data.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        removeSysImage(data) {
            return http.json({
                url: `/system/sysImage/delete?id=${data[0].id}`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/sysImage.js